module.exports = __webpack_public_path__ + "static/media/SAJ_03.7d704f22.jpeg";